import "@/ds/vendor/colors_and_type.css";
import "@/ds/vendor/patterns/glass-motion.css";
import "@/ds/vendor"; // registers the design-system namespace components look each other up in
import "@/ui/foundation.css";
import "@/ui/app.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { Boot } from "@/app/Boot";
import { router } from "@/app/router";
import { applyTheme } from "@/ui/theme";

applyTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Boot>{(boot) => <RouterProvider router={router} context={{ boot }} />}</Boot>
  </StrictMode>,
);
